/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'embedded-confluence-common.src.content.empty-state-description': '자세히 둘러보았지만 찾을 수가 없습니다. 삭제되었을 수 있습니다. URL에 입력 오류가 있는지 확인해보세요 😉',
  'embedded-confluence-common.src.content.empty-state-header': '원하는 항목을 찾을 수 없습니다',
  'embedded.confluence.already-logged-in-paragraph': '이미 로그인하셨습니까? 새로 고쳐 보세요.',
  'embedded.confluence.footer.hover.text': 'Confluence에서 보기',
  'embedded.confluence.footer.prefix': '제공:',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Confluence에 로그인',
  'embedded.confluence.login-page.login-button': 'Confluence에 로그인',
  'embedded.confluence.login-page.login-button.aria-label': '로그인 버튼',
  'embedded.confluence.login-page.login-text': '이 페이지를 보려면 로그인해야 합니다',
  'embedded.confluence.login-page.refresh-page-banner': '로그인하면 이 페이지가 자동으로 새로 고쳐집니다. 그렇지 않은 경우 여기를 클릭하여 새로 고칠 수 있습니다',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': '페이지 새로 고치기',
  'embedded.confluence.need-to-log-in-paragraph': '이 페이지를 보려면 로그인해야 합니다',
  'embedded.confluence.still-having-trouble-paragraph': '아직 문제가 있습니까? 타사 쿠키를 사용으로 설정했는지 확인하거나 {link}',
  'embedded.confluence.troubleshooting-link-text': '문제 해결 가이드를 참조하세요.',
  'embedded.confluence.troubleshooting-link.aria-label': '문제 해결 가이드 링크'
};